import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledMainContainer = styled.div`
	display: grid;
	grid-template-columns: 300px 1px 1fr;
	height: 100%;
`;

const StyledPhotoContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 260px;
	background-color: rgba(0, 0, 0, 0.25);

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledPhotoThumbsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
`;

const StyledPhotoThumb = styled.div<{
	$active?: boolean;
	$index: number;
	$disabled?: boolean;
}>`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 80px;
	box-sizing: border-box;
	cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};

	&::after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		border: 3px solid transparent;
		transition: border 0.3s ease;
	}

	img {
		transition: opacity 0.3s ease;
		user-select: none;
		pointer-events: none;
	}

	${(props) =>
		props.$index === 0 &&
		css`
			background-color: rgba(255, 255, 255, 0.1);
		`}

	${(props) =>
		props.$index === 1 &&
		css`
			background-color: rgba(255, 255, 255, 0.05);
		`}

        ${(props) =>
		props.$index === 2 &&
		css`
			background-color: rgba(255, 255, 255, 0.02);
		`}

	${(props) =>
		props.$active &&
		css`
			&::after {
				border: 3px solid #2d70da;
			}
		`}
`;

const StyledStatsContainer = styled.div`
	display: flex;
	padding: 20px;
	flex-direction: column;
	gap: 10px;
`;

const StatsTitleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		opacity: 0.75;
	}

	${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.75;
	}
`;

const StyledGraphContainer = styled.svg`
	border-radius: 5px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	background-color: rgba(0, 0, 0, 0.25);
`;

const StyledGraphHint = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	height: 30px;
	padding: 0 10px;
	gap: 10px;
	background: rgba(255, 255, 255, 0.9);
	border-radius: 10px;
	width: fit-content;
	pointer-events: none;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #000000;
	}
`;

const StyledGraphHintWrapper = styled.div`
	position: absolute;
	z-index: 10;
	pointer-events: none;
	transition: opacity 0.3s ease;
	transform: translateX(-50%);
`;

const StyledeItemListContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 20px 20px 0 20px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledItemList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	height: 285px;
	overflow-y: scroll;
	scrollbar-width: none;
	padding-bottom: 20px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledInfoContainer = styled.div`
	padding: 20px;
`;

const StyledOwnerContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 300px 40px;
	gap: 20px;
`;

const StyledUserContainer = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;

	& > ${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledUserButtonsContainer = styled.div`
	display: flex;
	gap: 10px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledInfoGrid = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	gap: 14px;
	justify-content: space-between;
	margin-top: 17px;

	${Text} {
		font-size: 14px;
		color: #ffffff;

		&:nth-child(2n + 1) {
			opacity: 0.25;
		}

		&:nth-child(2n) {
			text-align: right;

			span {
				opacity: 0.5;
			}
		}
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	margin-top: 15px;
`;

export {
	StatsTitleContainer,
	StyledButtonContent,
	StyledButtonsContainer,
	StyledeItemListContainer,
	StyledGraphContainer,
	StyledGraphHint,
	StyledGraphHintWrapper,
	StyledInfoContainer,
	StyledInfoGrid,
	StyledItemList,
	StyledMainContainer,
	StyledOwnerContainer,
	StyledPhotoContainer,
	StyledPhotoThumb,
	StyledPhotoThumbsContainer,
	StyledStatsContainer,
	StyledUserButtonsContainer,
	StyledUserContainer,
};
